<section class="row g-3">
  @for (product of products(); track product.id) {
  <div class="col-12 col-sm-6 col-md-4">
    <app-product-card-v2 [cardResume]="{ productDetails: product,settings: {isCrossSell: true}}"
      (outProductAdded)="removeProduct($event)"></app-product-card-v2>
  </div>
  }
</section>

<footer class="d-flex justify-content-center mt-4">
  <button class="btn btn-outline-primary" type="button" (click)="close()">
    Close
  </button>
</footer>